module.exports = __webpack_public_path__ + "static/img/image_we_08_02.b4498f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/image_we_08_02.png
// module id = gVXE
// module chunks = 10